<div class="sp-width__full sp-row__space sp-wrap">
  <div class="sp-row__align">
    <app-shared-order-channel
      [order]="order"
      [show_label]="false"></app-shared-order-channel>
    <app-shared-order-origin
      [order]="order"
      [show_label]="false"></app-shared-order-origin>
    <span class="sp-color__primary"> {{ (order?.amount?.total || 0) / 100 | number : '0.2-2' }}€ </span>
    <app-shared-pill
      class="sp-margin__left"
      [content]="getOrderStatusLabel(order?.status)"
      [pill_class]="getOrderStatusClass(order?.status)"></app-shared-pill>
  </div>

  <div class="sp-row__align">
    <span class="sp-color__primary"> {{ order?.created_at | date : 'short' }} </span>
  </div>
  <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__top" />
</div>
